import { setup } from 'bem-cn'
import areRangesOverlapping from 'date-fns/are_ranges_overlapping'
import isSameDay from 'date-fns/is_same_day'
import isWithinRange from 'date-fns/is_within_range'
import React, { Component } from 'react'
import CustomScroll from 'react-custom-scroll'
import DragDropContext from '../../../utils/dndcontext';
import { DAYS_OF_WEEK } from '../../constants'
import { getDaysArrayForMonth, splitDaysIntoWeeks } from '../../utils/month'
import i18n from 'i18next'

import Week from '../Week'

const block = setup({
    mod: '--'
})

const b = block('Month')

class Month extends Component {
    constructor(props) {
        super(props)

        this.state = {
            weeks: [],
            map: {}
        }
    }

    componentDidMount() {
        const { month, year } = this.props
        const days = getDaysArrayForMonth(month, year)
        const weeks = splitDaysIntoWeeks(days)

        this.setState({
            weeks,
            map: this.getTasksMap(weeks)
        })
    }

    componentDidUpdate(prevProps) {
        const { month, year } = this.props
        if (prevProps.month !== month || prevProps.year !== year) {
            const days = getDaysArrayForMonth(month, year)
            const weeks = splitDaysIntoWeeks(days)

            this.setState({
                weeks,
                map: this.getTasksMap(weeks)
            })
        } else if (!this.areTasksSame(prevProps.tasks)) {
            this.setState({
                map: this.getTasksMap(this.state.weeks)
            })
        }
    }

    comapreTasks(taskA, taskB) {
        if (!taskA || !taskB) {
            return false
        }
        return (
            isSameDay(taskA.startDate, taskB.startDate) && isSameDay(taskA.endDate, taskB.endDate)
        )
    }

    areTasksSame(prevTasks) {
        const { tasks } = this.props
        if (prevTasks.length !== tasks.length) {
            return false
        }

        for (let i = 0; i < tasks.length; i++) {
            if (!this.comapreTasks(prevTasks[i], tasks.find(t => t.id === prevTasks[i].id))) {
                return false
            }
        }

        return true
    }

    cmp(a, b) {
        if (a > b) return +1
        if (a < b) return -1
        return 0
    }

    getSortedTasks() {
        return this.props.tasks.sort((a, b) => {
            return this.cmp(a.startDate, b.startDate) || this.cmp(b.duration, a.duration)
        })
    }

    getWeekTasks(tasks, startDate, endDate) {
        return tasks.filter(task => {
            return this.isWeekTask(task, startDate, endDate)
        })
    }

    isWeekTask(task, weekStartDate, weekEndDate) {
        return (
            isSameDay(weekStartDate, task.endDate) ||
            isSameDay(weekEndDate, task.startDate) ||
            areRangesOverlapping(weekStartDate, weekEndDate, task.startDate, task.endDate)
        )
    }

    getCurrentTask() {
        const { currentTask } = this.props

        if (!Number.isInteger(currentTask.id)) {
            return null
        }

        const task = this.props.tasks.find(task => task.id === currentTask.id)

        return {
            ...task,
            startDate: currentTask.startDate || task.startDate,
            endDate: currentTask.endDate || task.endDate
        }
    }

    getTasksMap(weeks) {
        const { tasks } = this.props
        const map = {}

        const findFreePosition = arr => {
            const _arr = arr.sort((a, b) => a - b)
            const max = Math.max.apply(null, _arr)
            for (let i = 0; i < max; i++) {
                if (_arr.indexOf(i) === -1) {
                    return i
                }
            }
            return null
        }

        const sortedTasks = tasks.sort((a, b) => {
            return this.cmp(a.startDate, b.startDate) || this.cmp(b.duration, a.duration)
        })

        weeks.forEach(week => {
            const weekTasks = this.getWeekTasks(sortedTasks, week.startDate, week.endDate)
            map[week.num] = {}
            week.days.forEach(day => {
                let inc = 0
                const date = day.date
                map[week.num][date.getDay()] = {}
                weekTasks
                    .filter(
                        task =>
                            isSameDay(date, task.startDate) ||
                            isWithinRange(date, task.startDate, task.endDate)
                    )
                    .forEach(task => {
                        if (
                            date.getDay() > 0 &&
                            Number.isInteger(map[week.num][date.getDay() - 1][task.id])
                        ) {
                            map[week.num][date.getDay()][task.id] =
                                map[week.num][date.getDay() - 1][task.id]
                        } else {
                            const free = findFreePosition(
                                Object.values(map[week.num][date.getDay()])
                            )
                            map[week.num][date.getDay()][task.id] = Number.isInteger(free)
                                ? free
                                : inc
                        }
                        inc++
                    })
            })
        })

        return map
    }

    render() {
        const { colors, tasks } = this.props
        const { weeks, map } = this.state
        const currentTask = this.getCurrentTask()
        return (
            <div className={b()}>
                <CustomScroll heightRelativeToParent="100%">
                    <div className={b('body')}>
                        <div className={b('header')}>
                            {DAYS_OF_WEEK.map((day, i) => (
                                <div key={i} className={b('weekday', { weekend: i === 0 || i === 6 })}>
                                    {i18n.t('calendar:days of week.' + day)}
                                </div>
                            ))}
                        </div>

                        <div className={b('main', { dragging: !!currentTask })}>
                            {weeks.map(week => (
                                <Week
                                    key={week.num}
                                    {...week}
                                    tasks={this.getWeekTasks(tasks, week.startDate, week.endDate)}
                                    map={map[week.num]}
                                    currentTask={currentTask}
                                    colors={colors}
                                />
                            ))}
                        </div>
                    </div>
                </CustomScroll>
            </div>
        )
    }
}

export default DragDropContext(Month)
